var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgBlank(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8872_9859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.6667 23.9987V7.9987C30.6667 6.53203 29.4667 5.33203 28 5.33203H4.00004C2.53337 5.33203 1.33337 6.53203 1.33337 7.9987V23.9987C1.33337 25.4654 2.53337 26.6654 4.00004 26.6654H28C29.4667 26.6654 30.6667 25.4654 30.6667 23.9987ZM11.8667 17.3054L14.6667 20.6787L18.8 15.3587C19.0667 15.012 19.6 15.012 19.8667 15.372L24.5467 21.612C24.88 22.052 24.56 22.6787 24.0134 22.6787H8.02671C7.46671 22.6787 7.16004 22.0387 7.50671 21.5987L10.8267 17.332C11.08 16.9854 11.5867 16.972 11.8667 17.3054V17.3054Z",
    fill: "#E9E9E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8872_9859"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgBlank);
export default __webpack_public_path__ + "static/media/ImgBlank.6a0d837efb8bd892e3e9db93b4708a1c.svg";
export { ForwardRef as ReactComponent };